import { useMemo } from 'react';
import { defaultXAxisOptions, defaultYAxisOptions } from '../constants';

const MAX_TITLE_LENGTH = 24;

function useDeviceTimeSeriesScales({ datasets, scales, displayAxisTitle }) {
  const scaleMap = useMemo(() => scales.reduce((acc, scale) => acc.set(scale.key, scale), new Map()), [scales]);

  return useMemo(
    () => datasets.reduce((acc, dataset) => addChartScale(acc, dataset, scaleMap, { displayAxisTitle }), {}),
    [datasets, scaleMap, displayAxisTitle]
  );
}

function addChartScale(acc, dataset, scales, options) {
  const { label, xAxis, yAxis } = dataset;

  if (yAxis) {
    const scale = scales.get(yAxis);

    if (!acc[yAxis]) {
      acc[yAxis] = toChartScale(scale, defaultYAxisOptions, options);
    }

    if (options?.displayAxisTitle && acc[yAxis].title && !scale?.label) {
      acc[yAxis].title = resolveScaleTitle(acc[yAxis].title, label);
    }
  }

  if (xAxis && !acc[xAxis]) {
    const scale = scales.get(xAxis);
    acc[xAxis] = toChartScale(scale, defaultXAxisOptions);
  }

  return acc;
}

function toChartScale(scale = {}, baseScale, { displayAxisTitle = false } = {}) {
  return {
    ...baseScale,
    position: scale.position ?? baseScale.position,
    title: scale.label != null && {
      ...baseScale.title,
      display: displayAxisTitle,
      text: scale.label
    }
  };
}

function resolveScaleTitle(title, label) {
  let { text } = title;

  if (text.length === MAX_TITLE_LENGTH) {
    return title;
  }

  if (text.length > 0) {
    text = [text, label].join(', ');
  } else {
    text = label;
  }

  if (text.length > MAX_TITLE_LENGTH) {
    text = `${text.substring(0, MAX_TITLE_LENGTH - 3)}...`;
  }

  return { ...title, text };
}

export { useDeviceTimeSeriesScales };
